export default __webpack_public_path__ + "static/media/deal-9.cf14c436.webp";